import React, { FC, useRef } from "react";
import JoditEditor from "jodit-react";

type TexEditorProps = {
  value: string;
  onChange: (value: string) => void;
};

const TexEditor: FC<TexEditorProps> = ({ onChange, value }) => {
  const editor = useRef(null);

  return (
    <JoditEditor
      ref={editor}
      value={value}
      config={{
        readonly: false,
        placeholder: "Start typings...",
      }}
      onBlur={(newContent: string) => {
        onChange(newContent);
      }}
    />
  );
};

// export default TexEditor;

// import { FC } from "react";

// import { Box, useTheme } from "@mui/material";
// import { Editor } from "@tinymce/tinymce-react";

// type TexEditorProps = {
//   value: string;
//   onChange: (value: string) => void;
// };

// const TexEditor: FC<TexEditorProps> = ({ value, onChange }) => {
//   const theme = useTheme();

//   const handleChange = (e: any) => {
//     onChange(e.target.getContent());
//   };

//   return (
//     <Box>
//       <Editor
//         apiKey="qdfqcknyl4kl3rvcxo7492zwxakhw26t5g855yjwz8t41dwk"
//         onChange={handleChange}
//         initialValue={value}
//         init={{
//           height: 700,
//           menubar: true,
//           icons: "material",
//           plugins: [
//             "advlist",
//             "autolink",
//             "lists",
//             "link",
//             "image",
//             "charmap",
//             "anchor",
//             "searchreplace",
//             "visualblocks",
//             "code",
//             "fullscreen",
//             "insertdatetime",
//             "media",
//             "table",
//             "preview",
//             "help",
//             "wordcount",
//             "image",
//             "quickimage",
//             "quicklink",
//             "quicktable",
//             "searchreplace",
//             "table",
//             "blockquote",
//             "editimage",
//             "fliph",
//             "flipv",
//             "imageoptions",
//             "rotateleft",
//             "rotateright",
//             "emoticons",
//             "media",
//             "preview",
//             "lineheight",
//           ],
//           toolbar: [
//             "undo redo  | blocks | fontsize | lineheight | bold italic forecolor blockquote |  alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | backcolor forecolor",
//             " table | charmap emoticons | image media | link  openlink unlink | removeformat | preview fullscreen | searchreplace help ",
//           ],
//           content_style: `body { font-family:${theme.typography.fontFamily} }`,
//         }}
//       />
//     </Box>
//   );
// };

export default TexEditor;
